import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Check Fill
 */

export default function CheckFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M13.6585 3.24744C14.0742 3.61112 14.1163 4.24288 13.7526 4.65852L6.7526 12.6585C6.56064 12.8779 6.28252 13.0026 5.99103 13C5.69955 12.9974 5.42371 12.8677 5.23573 12.6449L2.23573 9.08933C1.87958 8.66722 1.93304 8.03632 2.35515 7.68017C2.77726 7.32401 3.40816 7.37748 3.76431 7.79959L6.01381 10.4657L12.2474 3.34151C12.6111 2.92587 13.2429 2.88375 13.6585 3.24744Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
